var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInattention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,92.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463 771 c-89 -41 -110 -164 -41 -238 38 -41 11 -36 -31 6 -45 45 -92 59 -144 42 -37 -13 -90 -60 -119 -106 -33 -54 -19 -61 17 -8 47 71 88 98 147 98 70 0 106 -40 159 -174 40 -102 59 -138 59 -114 0 6 -7 29 -15 52 -17 48 -13 50 63 21 29 -11 65 -20 81 -20 43 0 171 31 171 41 0 12 -5 11 -70 -6 -80 -22 -90 -20 -90 14 0 28 3 30 78 48 63 16 78 23 80 40 3 18 -8 25 -76 49 l-79 28 13 33 c32 75 1 158 -71 193 -51 25 -78 25 -132 1z m134 -21 c75 -45 84 -148 19 -207 -31 -28 -43 -33 -87 -33 -46 0 -55 4 -90 39 -33 32 -39 45 -39 80 0 110 107 176 197 121z m115 -246 c89 -32 98 -39 58 -47 -17 -4 -55 -14 -85 -23 -53 -15 -55 -17 -55 -51 0 -40 -3 -40 -106 -2 -45 17 -59 28 -70 55 -8 18 -14 38 -14 44 0 6 28 10 68 10 50 0 75 5 97 20 17 11 31 20 32 20 1 0 35 -12 75 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728 403 c-32 -8 -58 -19 -58 -25 0 -5 8 -7 18 -5 9 3 41 11 70 17 28 7 52 16 52 21 0 12 -12 10 -82 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 317 c-14 -40 -15 -47 -3 -47 5 0 12 10 15 23 l7 22 16 -22 c26 -38 35 -26 13 17 -11 22 -24 40 -28 40 -4 0 -13 -15 -20 -33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInattention);
export default __webpack_public_path__ + "static/media/inattention.f70afb7d25c40aaf789aeaa335dfa5cf.svg";
export { ForwardRef as ReactComponent };